import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";

import { getSurveys } from "../../services/portalAluno/surveys/surveysService";
import type { ApplicationState } from "../../store";

export const portalSurveysQueryKey = (idUsuario?: number) => [
  "portal-aluno",
  "enquetes-pesquisas",
  idUsuario,
];

const useSurveys = () => {
  const auth = useSelector((state: ApplicationState) => state.auth.data);
  const idUsuario = auth?.idUsuario;

  return useQuery({
    enabled: Boolean(idUsuario),
    queryKey: portalSurveysQueryKey(idUsuario),
    queryFn: () => getSurveys(),
  });
};

export default useSurveys;
